import {SmPhotoGalleryComponent} from '../sm-photo-gallery/sm-photo-gallery.component';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {SmImagePreviewComponent} from './sm-image-preview.component';

@NgModule({
  imports: [
    CommonModule,
    SmPhotoGalleryComponent,
    IonicModule,
  ],
  declarations: [SmImagePreviewComponent],
  exports: [SmImagePreviewComponent],
})
export class SmImagePreviewModule {}
